import { useTranslation } from "react-i18next";

export type EnduserCompareEntityType = "parcours" | "modules" | "groupes_parcours";

interface EnduserRankingSubTabsProps {
  activeTab: EnduserCompareEntityType;
  onTabChange: (tab: EnduserCompareEntityType) => void;
}

const EnduserRankingSubTabs = ({ activeTab, onTabChange }: EnduserRankingSubTabsProps) => {
  const { t } = useTranslation();

  const tabs: { key: EnduserCompareEntityType; label: string }[] = [
    { key: "parcours", label: t("enduserStats.comparateur.subTabs.parcours") },
    { key: "modules", label: t("enduserStats.comparateur.subTabs.modules") },
    { key: "groupes_parcours", label: t("enduserStats.comparateur.subTabs.groupesParcours") },
  ];

  return (
    <div className="inline-flex bg-gray-100 rounded-lg p-1">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-all ${
            activeTab === tab.key
              ? "bg-white text-gray-900 shadow-sm"
              : "text-gray-600 hover:text-gray-900"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default EnduserRankingSubTabs;
